import React from 'react';
import UninvoiceableAssignmentItem from '../../../../../Domain/UninvoiceableAssignmentItem';
import TabOfDataTable from '../../../../../Elements/DataTable/TabOfDataTable';
import GeneralEditWizzardBase from '../../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ButtonColorsEnum from '../../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../../Enums/ButtonTypeEnum';
import CrudTypesEnum from '../../../../../Enums/CrudTypesEnum';
import IconPositionEnum from '../../../../../Enums/IconPositionEnum';
import ShownPanelsEnum from '../../../../../Enums/ShownPanelsEnum';
import ProjectAssignmentService from '../../../../../Services/ProjectAssignmentsService';
import AssignmentSearchParams from '../AssignmentSearchParams';
import EditProjectAssignmentWindowDescription from '../EditProjectAssignmentWindowDescription';
import AssignmentsListBase from './AssignmentsListBase';
import FigmaButtonRow from '../../../../../Elements/FigmaButtonRow';

export default class UninvoiceableAssignmentsList extends AssignmentsListBase {
  constructor(props) {
    super(props);

    this.clickOnUpdateMultipleButton = this.clickOnUpdateMultipleButton.bind(this);
    EditProjectAssignmentWindowDescription.getSelected = this.getSelected.bind(this);
    EditProjectAssignmentWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    EditProjectAssignmentWindowDescription.getAllItemInTheSearchAreSelected =
      this.getAllItemInTheSearchAreSelected.bind(this);
  }

  isAnyItemSelected() {
    return this.state.itemList.find((u) => u.Selected === true) !== undefined;
  }

  getAllItemInTheSearchAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  clickOnUpdateMultipleButton(selectedId, selectedItem) {
    this.setState({
      selectedItem: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditProjectAssignmentWindowDescription}
            errorCode={'UAL65'}
          />
        )}
        {super.renderPanels()}
      </div>
    );
  }

  renderActionButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-rectangle-history-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnUpdateMultipleButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Update Multiple',
            roleKey: 'assignment_edit',
          },
        ]}
      />
    );
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.refresh();
    }
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    this.refresh();
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    return ProjectAssignmentService.GetAssignmentList(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      this.getSearchParameters(searchItem),
      clearCache
    );
  }

  getTabOfDataTable() {
    return (
      <div>
        {this.renderPanels()}
        <TabOfDataTable
          type={UninvoiceableAssignmentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={this.serviceFunction.bind(this)}
          convertDBItemsFunction={ProjectAssignmentService.ConvertUninvoiceableDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={AssignmentSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          itemTypeName={'assignments'}
          enableUrlPush={false}
          errorCode='UAL136'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Apollo/Location ID and country code...'
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
